/* squiq-cards — Kartenmuster-Schalter, generisch.
 *
 * Herkunft: snippets/squiq-cards.liquid aus dem Design-Staging 206887911749
 * (TSK-1740, 22.09.). Fuer D2 aus dem Snippet in ein eigenes Asset gehoben,
 * damit theme.liquid keinen neunten Inline-Hook bekommt — dasselbe Muster wie
 * squiq-cart-validation.js / squiq-preorder-pickup.js / squiq-attribution.js
 * aus der D1-Haertung.
 *
 * Eine Section meldet sich selbst an, indem sie im Theme-Editor-Feld
 * "Custom CSS" genau eine Zeile traegt:
 *
 *     {--squiq-cards: 1;}        (Varianten-Kacheln)
 *     {--squiq-bildkarten: 1;}   (Querverweis-Karten, seit 24.09.)
 *     {--squiq-insta-logo: 1;}   (Instagram-Logo statt Text, seit 24.09.)
 *
 * Dieses Skript hebt die Markierung in die Klasse .squiq-cards; die Regeln
 * dazu stehen einmalig in assets/squiq-custom.css. Im CSS steht damit keine
 * Instanz-ID mehr — das Muster laesst sich auf jede weitere multicolumn-Section
 * ausrollen, ohne CSS anzufassen.
 *
 * Faellt die Markierung weg (Section im Editor neu angelegt), faellt die Klasse
 * sichtbar mit. Es gibt keinen stillen Zustand, in dem das CSS auf eine tote
 * Kennung zeigt und trotzdem im Theme steht.
 */
(function () {
  function anwenden() {
    // Seit 24.09. zwei Muster: --squiq-cards (Varianten-Kacheln) und
    // --squiq-bildkarten (Querverweis-Karten, Bild ist die Kachel).
    var muster = ['squiq-cards', 'squiq-bildkarten', 'squiq-insta-logo'];
    document.querySelectorAll('[id^="shopify-section"]').forEach(function (el) {
      var st = getComputedStyle(el);
      muster.forEach(function (m) {
        el.classList.toggle(m, st.getPropertyValue('--' + m).trim() === '1');
      });
    });
  }
  // Bild-Link-Label (seit 24.09. abends, TSK-1740): das Theme baut das
  // aria-label des Bild-Links als "{{ Titel }} anzeigen" (lokalisiert: "View ",
  // "Voir ", " bekijken" ...). Wo die Karte ihren Text im Fliesstext statt im
  // Titel traegt (Start, Camping, Alltag, Gewerbe), bleibt nur " anzeigen".
  // Dann den ersten Absatz der Karte einsetzen -- er ist je Sprache schon
  // uebersetzt, das Verb des Themes bleibt stehen. Karten mit Titel bleiben
  // unberuehrt. Kein Uebersetzungs-Write noetig.
  function labels() {
    document.querySelectorAll('.multicolumn-card a.full-unstyled-link[aria-label]').forEach(function (a) {
      var karte = a.closest('.multicolumn-card');
      var titel = karte.querySelector('.multicolumn-card__title');
      if (titel && titel.textContent.trim() !== '') return;
      var p = karte.querySelector('.multicolumn-card__info .rte p, .multicolumn-card__info .rte');
      var text = p ? p.textContent.replace(/\s+/g, ' ').trim() : '';
      if (!text) return;
      var l = a.getAttribute('aria-label');
      if (l.trim() === '' || l.indexOf(text) !== -1) return;
      a.setAttribute('aria-label', /^\s/.test(l) ? text + l : l + text);
    });
  }
  function alles() { anwenden(); labels(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alles);
  } else {
    alles();
  }
  document.addEventListener('shopify:section:load', alles);
})();
